import { useTranslation } from 'react-i18next';
import { testimonials } from '@/mocks/home';

export default function Testimonials() {
  const { t } = useTranslation();

  return (
    <section className="w-full py-14 md:py-20 bg-secondary-100/50">
      <div className="w-full px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <div className="inline-flex items-center gap-2 px-3 py-1 bg-secondary-200/60 rounded-full mb-4">
            <i className="ri-heart-fill text-primary-500 text-sm"></i>
            <span className="text-xs font-medium text-secondary-700">漫友推荐</span>
          </div>
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900">
            {t('common:testimonialsTitle')}
          </h2>
          <p className="text-sm text-foreground-500 mt-2 max-w-lg mx-auto">
            听听漫友们怎么说，一起加入韩漫屋的大家庭
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5 max-w-5xl mx-auto">
          {testimonials.slice(0, 5).map((item, index) => {
            const isLarge = index === 3;
            const colSpan = isLarge ? 'lg:col-span-2' : '';

            return (
              <div
                key={item.id}
                className={`relative bg-background-50 rounded-lg p-5 md:p-6 ${colSpan}`}
              >
                <i className="ri-double-quotes-l text-3xl md:text-4xl text-primary-200 absolute top-4 right-5"></i>
                <div className="flex items-center gap-3 mb-4">
                  <div className="w-10 h-10 md:w-12 md:h-12 rounded-full overflow-hidden bg-background-200 flex-shrink-0">
                    <img
                      src={item.avatar}
                      alt={item.name}
                      className="w-full h-full object-cover"
                      loading="lazy"
                    />
                  </div>
                  <div>
                    <p className="text-sm font-medium text-foreground-900">{item.name}</p>
                    <p className="text-xs text-foreground-500">{item.role}</p>
                  </div>
                  <div className="ml-auto flex items-center gap-0.5">
                    {Array.from({ length: item.rating }).map((_, i) => (
                      <i key={i} className="ri-star-fill text-accent-400 text-xs"></i>
                    ))}
                  </div>
                </div>
                <p className="text-sm text-foreground-700 leading-relaxed">
                  {item.content}
                </p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}